<template>
  <div class="track-and-trace-wrapper" v-if="getTrackAndTraceConfig.language !== undefined">
    <template v-if="!editing">
      <TrackAndTraceHeader :editing="editing" :customRoute="getMatchedCustomRoute" ref="trackAndTraceHeader" />
      <TrackAndTraceBanner :editing="editing" :customRoute="getMatchedCustomRoute" ref="trackAndTraceBanner"/>
      <TrackAndTraceInformation :orderStatus="orderStatus" :customRoute="getMatchedCustomRoute" :editing="editing" ref="trackAndTraceInformation" />
    </template>
    <TrackAndTraceContent :orderStatus="orderStatus" :editing="editing" ref="trackAndTraceContent" @back="$emit('back')" />
  </div>
</template>

<script>
import TrackAndTraceHeader from './TrackAndTraceHeader.vue';
import TrackAndTraceBanner from './TrackAndTraceBanner.vue';
import TrackAndTraceInformation from "./TrackAndTraceInformation.vue";
import TrackAndTraceContent from "./TrackAndTraceContent.vue";
import MotivateLogoWrapper from "./MotivateLogoWrapper.vue";
import {mapGetters} from "vuex";
import {matchRouteForOrder} from "@/utils/trackAndTraceRoute";

export default {
  name: "TrackAndTrace",
  props: ['editing', 'orderStatus'],
  components: {
    MotivateLogoWrapper,
    TrackAndTraceContent, TrackAndTraceInformation, TrackAndTraceHeader, TrackAndTraceBanner},
  computed: {
    ...mapGetters('trackAndTrace', ['getTrackAndTraceConfig']),
    ...mapGetters(['getLocale']),
    getMatchedCustomRoute() {
      // Only relevant on the public (non-editing) page - the Main tab's own settings are
      // edited/shown as-is regardless of custom routes.
      if (this.editing) {
        return null;
      }
      const customRoutes = this.getTrackAndTraceConfig.customRoutes;
      if (!customRoutes || !customRoutes.length) {
        return null;
      }
      return matchRouteForOrder(this.orderStatus, customRoutes) || null;
    }
  },
  created() {
    if (!this.editing) {
      // Make track and trace bigger
      $("html").css("font-size", "20px");
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/MotivateColors";

.track-and-trace-wrapper {
  background: $ultraLightGrey;
  min-height: 100%;
}


</style>